import { organizationEntityName } from '../../../../../../backend/features/organizations/shared';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { ModalSlideout } from '@juvare/common-web-ui/ModalSlideout';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { useStorageGet, useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import { Box } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
import { OrganizationDetails } from './OrganizationDetails';
export const OrganizationSlideout = ({ organizationId, onClose, onReload, onResolveNavigationPathname, }) => {
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const { data: orgData, isLoading: orgDataIsLoading, error: orgDataError, mutate: fetchOrg, } = useStorageGet(organizationEntityName, organizationId);
    const { data: orgChildrenCountData, isLoading: orgChildrenCountIsLoading, error: orgChildrenContError, mutate: fetchOrgChildrenCount, } = useStorageList(organizationEntityName, organizationId
        ? {
            filter: [
                {
                    op: 'or',
                    filter: [
                        { parentId: organizationId, op: '=' },
                        { column: 'parentIds', op: 'overlap', value: [organizationId] },
                    ],
                },
            ],
            limit: 0,
        }
        : undefined);
    const isLoading = orgDataIsLoading || orgChildrenCountIsLoading;
    const error = orgDataError || orgChildrenContError;
    if (isLoading || error || !organizationId || !orgData || !orgChildrenCountData) {
        return null;
    }
    return (React.createElement(ModalSlideout, { open: !!organizationId, onClose: () => {
            onClose();
        }, "data-test": 'organization-slideout' },
        React.createElement(Box, { sx: {
                overflow: 'auto',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: themeColors.surface.primary,
            }, "data-test": 'organization-details' },
            React.createElement(OrganizationDetails, { organization: orgData, orgChildrenCount: orgChildrenCountData.total, onReload: () => {
                    fetchOrg();
                    fetchOrgChildrenCount();
                    onReload === null || onReload === void 0 ? void 0 : onReload();
                }, onClose: onClose, onEditSection: () => undefined, onResolveNavigationPathname: onResolveNavigationPathname, onHistorySection: () => {
                    navigationContext.navigate(() => navigate({
                        pathname: onResolveNavigationPathname
                            ? onResolveNavigationPathname('history')
                            : organizationId + '/history',
                    }, { state: { back: true } }));
                } }))));
};
